import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import React, { Fragment, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import EOCDetails from './ComponentReuse/EOCDetails';

function HistoryDetailDialog(props) {

    const { open, setOpen, eocData, activityData } = props;
    const [isHidden, setIsHidden] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={open}
                className={isHidden ? 'hidden' : 'block'}
            >
                <DialogTitle className='py-3'>
                    <div>
                        <div className='flex justify-between items-center'>
                            <Typography variant="h6">รายละเอียด EOC</Typography>
                            <IconButton
                                edge="start"
                                color="rgb(0, 0, 0)"
                                onClick={handleClose}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent className='md:px-16' dividers>
                    <EOCDetails eocData={eocData} activityData={activityData} setIsHidden={setIsHidden}/>
                </DialogContent>
            </Dialog>
        </Fragment>
    )
}

export default HistoryDetailDialog